module.exports = __webpack_public_path__ + "img/Contacts.e8ba03d0.svg";